<div class="modal-header" ngbAutofocus>
    <h3 class="modal-title">Expense Added</h3>
</div>
<div class="modal-body">

    <div *ngIf="!errorMsg||errorMsg.trim()===''">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
                You have successfully added a new expense.
            </div>
        </div>
        <div class="row" style="margin-top:10px;">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <label style="font-weight:700">Description:</label>
                <input type="text" class="form-control" [(ngModel)]="expenseData.Description" />
            </div>
        </div>
        <div class="row" style="margin-top:10px;">
            <div class="col-lg-3 col-md-5 col-sm-12">
                <label style="font-weight: 700">Gross Amount:</label>
                <input currencyMask type="text" [options]="options" class="form-control" [(ngModel)]="expenseData.Amount" />
            </div>
        </div>
        <div class="row" style="margin-top:10px;">
            <div class="col-lg-3 col-md-5 col-sm-12">
                <label style="font-weight:700">Transaction Date:</label>
                <div class="input-group">
                    <input type="text"
                           class="form-control"
                           bsDatepicker
                           #fromdp="bsDatepicker"
                           [(ngModel)]="expenseData.ExpenseDate"
                           [outsideClick]="true"
                           [bsConfig]="bdatePickerOptions"
                           [readonly]="mobileMode"
                           style="background-color:#ffffff">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                                (click)="fromdp.show()"
                                [attr.aria-expanded]="fromdp.isOpen"
                                style="margin-right:0px">
                            <i class="oi oi-calendar"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top:10px;" *ngIf="catList != null && catList.length > 0 && showExpenseCategory">
            <div class="col-lg-3 col-md-5 col-sm-12">
                <label style="font-weight:700">Category</label>
                <ng-select [(ngModel)]="expenseData.ExpenseCatgID"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let data of catList" [value]="data.ExpenseCatgID">{{data.ExpenseCatgName}}</ng-option>
                </ng-select>
            </div>
        </div>

        <div *ngIf="savedFiles && savedFiles.length > 0">
            <div class="row" style="margin-top:10px;">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <label style="font-weight:700">Attachments: </label>
                    <ng-select [(ngModel)]="formData.selectedAttachment"
                               bindLabel="AttachmentFileName"
                               [searchable]="false"
                               [clearable]="false"
                               (change)="attachmentChange()"
                               dropdownPosition="bottom">
                        <ng-option *ngFor="let data of savedFiles" [value]="data">{{data.AttachmentFileName}}</ng-option>
                    </ng-select>
                    <div *ngIf="!showViewer" style="margin-top:15px;">
                        <span>Attachment: </span><a href="/Document/GetDBAttachment?attachmentID={{formData.selectedAttachment.FileAttachmentID}}">{{formData.selectedAttachment.AttachmentFileName}}</a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-1 col-md-1 col-sm-1"></div>
                <div class="col-lg-10 col-md-10 col-sm-10">
                    <ejs-pdfviewer id="pdfViewerConfirmation" *ngIf="showViewer"
                                   [serviceUrl]='service'
                                   [documentPath]=''
                                   [enableFormFields]='false'
                                   [enableFormDesignerToolbar]='false'
                                   [enableDownload]="true"
                                   [isSignatureEditable]="false"
                                   style="height:640px;display:block">
                    </ejs-pdfviewer>
                </div>
            </div>
        </div>

    </div>
    <div *ngIf="errorMsg && errorMsg.trim()!=''">
        {{errorMsg}}
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="openEditExpenseModal()" *ngIf="!errorMsg||errorMsg.trim()===''">Edit Expense Info</button>
    <button type="button" class="btn btn-default" (click)="cancelClicked()">Close</button>
</div>
